import {useContext, useRef, useState} from "react";
import SpinLoadingIndicator from "../../common/SpinLoadingIndicator";
import {UserActions, UserContext, UserDispatchContext} from "../../contexts/UserContext";
import BasicTextInput from "../../common/TextInput";
import {BasicButton, BasicButtonColor} from "../../common/Button";
import RegisterModal from "./RegisterModal";
import ErrorMessage from "../../common/ErrorMessage";

export default function LogIn() {
    // const [errorData, setErrorData] = useState(null);
    // const [signingIn, setSigningIn] = useState(false);
    const [registeringOpen, setRegisteringOpen] = useState(false);
    const [user, userDispatch] = [useContext(UserContext), useContext(UserDispatchContext)];

    const loginEmail = useRef(null);
    const loginPassword = useRef(null);
    const keepSignedIn = useRef(null);

    // async function onSubmit(submitEvent) {
    //     submitEvent.preventDefault();
    //     if (signingIn)
    //         return; // this probably shouldn't happen
    //     const loginData = {
    //         email: loginEmail.current.value,
    //         password: loginPassword.current.value,
    //         keepSignedIn: keepSignedIn.current.checked,
    //     };
    //
    //     setErrorData(null);
    //     setSigningIn(true);
    //     const result = await backend.login(loginData);
    //     setSigningIn(false);
    //
    //     if (!result.isSuccess()) {
    //         setErrorData(result);
    //     } else {
    //         setErrorData(null);
    //         userDispatch({
    //             type: UserActions.Login, user: result.data
    //         });
    //     }
    // }

    function onSubmit(submitEvent) {
        submitEvent.preventDefault();
        if (user.status.isLoading())
            return; // this probably shouldn't happen
        const loginData = {
            email: loginEmail.current.value,
            password: loginPassword.current.value,
            keepSignedIn: keepSignedIn.current.checked,
        };
        userDispatch({
            type: UserActions.RequestLogin,
            loginData: loginData,
        });
    }

    return (
        <>
            <form onSubmit={onSubmit}>
                <h2 className="text-4xl">Sign in</h2>
                <div className="mb-5"></div>
                <p>Sign in to back up your data, track your achievements, and more.</p>
                <div className="mb-5"></div>
                <BasicTextInput ref={loginEmail} type="text" name="email" autoComplete="username" required={true}
                                label="Email"/>
                <div className="mb-4"></div>
                <BasicTextInput ref={loginPassword} type="password" name="password"
                                autoComplete="current-password" required={true} label="Password"/>
                <div className="form-group">
                    <div className="mb-4"></div>
                    <label htmlFor="login-keep-signed-in">Keep me signed in</label>
                    <input
                        ref={keepSignedIn}
                        type="checkbox"
                        id="login-keep-signed-in"
                        name="keep-signed-in"
                        className="ml-2 w-4 h-4 rounded text-blue-600 bg-gray-100 border-gray-300"
                    />
                </div>
                <div className="mb-5"></div>
                <ErrorMessage data={user.status.getError()}/>
                <BasicButton type="submit" disabled={user.status.isLoading()} buttonColor={BasicButtonColor.Blue}>
                    {!user.status.isLoading() ? "Sign in" : <SpinLoadingIndicator/>}
                </BasicButton>
            </form>

            <div className="mb-8"></div>
            <hr/>
            <div className="mb-8"></div>
            <p>Don't have an account yet?</p>
            <div className="mb-2"></div>
            <BasicButton onClick={() => setRegisteringOpen(true)}>
                Register
            </BasicButton>
            {registeringOpen &&
                <RegisterModal onClose={() => setRegisteringOpen(false)}/>
            }
        </>
    );
}